import React from 'react';
import { Button, Form, Input, message, Divider } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const { TextArea } = Input;

export const ModalContactLogin = ({ handleModalClose }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    headers: { 'Content-Type': 'application/json' }
  });

  const sendMailHelp = async (body) => {
    try {
      await axiosInstance.post('/reclamations/sendContactMail', body);
      message.success(t(`basiclayout.footer.modal_bug_success`));
      handleModalClose();
    } catch (e) {
      if (e.response) message.error(e.response.status);
    }
  };

  const handleSubmit = (values) => {
    sendMailHelp(values);
    handleModalClose();
    form.resetFields();
  };

  return (
    <>
      <Form
        name="helpForm"
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 12 }}
        autoComplete="off"
        onFinish={handleSubmit}
      >
        <Form.Item label={t('basiclayout.footer.name_office')} name="name">
          <Input />
        </Form.Item>
        <Form.Item
          label={t('basiclayout.footer.first_name')}
          name="owner_first_name"
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t('basiclayout.footer.last_name')}
          name="owner_last_name"
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t('basiclayout.footer.phone_number')}
          name="phone_number"
        >
          <Input />
        </Form.Item>
        <Form.Item label={t('basiclayout.footer.email')} name="owner_email">
          <Input />
        </Form.Item>
        <Form.Item label={t('basiclayout.footer.object')} name="object">
          <Input />
        </Form.Item>
        <Form.Item label={t('basiclayout.footer.message')} name="content">
          <TextArea />
        </Form.Item>
        <Divider />
        <Form.Item wrapperCol={{ offset: 10, span: 16 }}>
          <Button type="primary" htmlType="submit">
            Envoyer
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

ModalContactLogin.propTypes = {
  handleModalClose: PropTypes.func.isRequired
};

export default ModalContactLogin;
